export default "__VITE_ASSET__woOB0e0f__"